import { createContext } from "react";
import { LearningModule } from "../../../../models/learningModules";
import { PrepFqQuestion } from "../../../../models/prepFqQuiz";
import { JournalEntry } from "../../../../models/users";

const LearningModulesContext = createContext<{
  learningModules: LearningModule[];
  learningModule: LearningModule | undefined;
  journalEntries: JournalEntry[];
  allQuestions: PrepFqQuestion[];
}>({
  learningModules: [],
  learningModule: undefined,
  journalEntries: [],
  allQuestions: [],
});

export default LearningModulesContext;
